package com.eladfinish.bible.contest.extensions

import com.eladfinish.bible.contest.common.json

/**
 * Developed by
 * @author Elad Finish
 */

expect fun String.formatString(vararg args: Any?): String

/**
 * Whether the string ends with a character outside the BMP (a surrogate pair, e.g. 📅), which
 * takes two [Char]s — so it must be taken/dropped as a pair, never split.
 */
fun String.endsWithEmoji(): Boolean =
    length > 1 && this[lastIndex - 1].isHighSurrogate() && this[lastIndex].isLowSurrogate()

inline fun <reified R : Any> String.convertToDataClass() =
    json.decodeFromString<R>(this)

/**
 * Remove the last character from a String.
 */
fun String.chop(): String =
    this.dropLast(1)

fun String.capitalizeWord(): String =
    this.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }

fun String.splitByRegex(regexString: String): List<String> =
    this.split(regexString.toRegex())

fun String.replaceRegex(regex: String, replacement: String): String =
    this.replace(regex.toRegex(), replacement)

fun String.replaceAllWithFunction(regex: String, replacer: (String) -> String): String =
    this.replace(regex.toRegex()) {
        replacer(it.value)
    }

fun String.matches(regexString: String): Boolean =
    this.matches(regexString.toRegex())

fun String.matchesAny(regexCollection: Collection<String>): Boolean =
    regexCollection.any { this.matches(it.toRegex()) }

fun String.asInnerRegex(): Regex = ".*?$this.*?".toRegex()

fun String.removePrecedingNumber(): String =
    this.replaceRegex(regex = "^\\d+[.)]\\s", replacement = "")

private const val ALEF_TAV = "[א-ת]"
fun String.removePrecedingOtPasuk(): String =
    this.replaceRegex(regex = "^${ALEF_TAV}+?\\s", replacement = "")

fun String.wrapWithParentheses(): String = "(${this})"

fun ordinalIndexOf(str: String?, searchStr: String?, ordinal: Int): Int =
    ordinalIndexOf(str = str, searchStr = searchStr, ordinal = ordinal, lastIndex = false)

@Suppress("SameParameterValue")
private fun ordinalIndexOf(str: String?, searchStr: String?, ordinal: Int, lastIndex: Boolean): Int {
    return if (str != null && searchStr != null && ordinal > 0) {
        if (searchStr.isEmpty()) {
            if (lastIndex) {
                str.length
            } else {
                0
            }
        } else {
            var found = 0
            var index = if (lastIndex) str.length else -1
            do {
                index = if (lastIndex) {
                    str.lastIndexOf(searchStr, index - 1)
                } else {
                    str.indexOf(searchStr, index + 1)
                }
                if (index < 0) {
                    return index
                }
                ++found
            } while (found < ordinal)
            index
        }
    } else {
        -1
    }
}

fun openTitleTag(prefix: String, title: String): String {
    return "<$prefix%s>".formatString(title)
}

fun closeTitleTag(prefix: String, title: String): String {
    return "</$prefix%s>".formatString(title)
}
